<template>
  <div class="bg">
    <headline :params="headLines"></headline>
    <div class="container">
        <div class="content">
            <!-- 视频 -->
            <div class="video-box" v-if="pageType=='video'">
                <div class="video">
                    <video :src="info.url" controls></video>
                </div>
                <div class="panel">
                    <ul>
                        <h4>{{info.title}}</h4>
                        <li>
                            <label>{{info.user}}</label>{{info.time}}
                        </li>
                    </ul>
                    <dl>
                        <li><label>格式</label>{{info.format}}</li>
                        <li><label>时长</label>{{info.duration}}</li>
                        <li><label>码率</label>{{info.rate}}</li>
                        <li><label>大小</label>{{info.size}}</li>
                        <li><label>宽度</label>{{info.width}}</li>
                    </dl>
                </div>
            </div>
            <!-- 音频 -->
            <div class="audio-box" v-if="pageType=='audio'">
                <div class="audio">
                    <div :class="{control: true, scrolling: scrollAudio}">
                        <img src="@assets/img/common/infoplayMax.png" alt="cover">
                    </div>
                    <ul>
                        <h4>{{info.title}}</h4>
                        <li class="sub">{{info.user}}</li>
                        <li class="sub">{{info.time}}</li>
                        <!-- <li class="panel-time"><span><i>00:02</i> / 39:49</span></li>
                        <li class="panel">
                            <span class="bg"></span>
                            <span class="speed"><i></i></span>
                        </li> -->
                        <li>
                          <audio @play="onAudio('play')" @pause="onAudio('pause')" class="controls" :src="info.url" controls controlsList="nodownload"></audio>
                        </li>
                    </ul>
                </div>
                <dl>
                    <li><label>格式</label>{{info.format}}</li>
                    <li><label>时长</label>{{info.duration}}</li>
                    <li><label>声道</label>{{info.track}}</li>
                    <li><label>码率</label>{{info.rate}}</li>
                    <li><label>大小</label>{{info.size}}</li>
                </dl>

            </div>
            <aside>
                <ul>
                    <li :class="{active:!changemedia}" @click="change(false)">无时间轴</li>
                    <li :class="{active:changemedia}" @click="change(true)">时间轴</li>
                </ul>
                <dl>
                    <div class="text" v-if="!changemedia">
                      {{content}}
                      <div class="operation">
                          <button class="export" @click="exportText(1)">导出文字</button>
                          <button>查看翻译</button>
                      </div>
                    </div>
                    <div class="timeList" v-if="changemedia">
                        <li>
                            <label><img @click="selectAll()" :src="selectedAll ? checkerOn : checker" class="checker" alt="checker"> 全选</label>
                        </li>
                        <li v-for="(l, i) in list" :key="i">
                            <label><img @click="selectOne(l)" :src="l.selected ? checkerOn: checker" class="checker" alt="checker">{{i}}</label>
                            <span class="times">
                                <i>{{l.begin}}</i><i>{{l.end}}</i>
                            </span>
                            <span class="info">{{l.result}}</span>
                        </li>
                         <div class="operation">
                            <button class="export" @click="exportText(2)">导出文字</button>
                        </div>
                    </div>
                </dl>
            </aside>
        </div>
    </div>
  </div>
</template>

<script>
import headline from '@components/headline'
import common from '@common/common'
import {apis} from '@common/config'

export default {
  components: {
    headline
  },

  data (){
      return {
        pageType: '',
        changemedia: false,
        selectedAll: false,
        checker: require('@assets/img/interview/checker.svg'),
        checkerOn: require('@assets/img/interview/checkerOn.svg'),
        headLines: {
          title: '',
          showLink: false,
          filter: false
        },
        content: '',
        list: [],
        info: {
          format: '',
          duration: '',
          track: '',
          rate: '',
          size: '',
          width: '',
          user: '',
          time: '',
          url: '',
          title: ''
        },
        scrollAudio: false,
        isXnew: true
      }
  },
    methods: {
      onAudio(action) {
        if (action === 'play') {
          this.scrollAudio = true
        } else {
          this.scrollAudio = false
        }
      },
      selectOne(i) {
        this.$set(i, 'selected', !i.selected)

        this.$nextTick(() => {
          if (!i.selected) {
            this.selectedAll = false
          }
        })
      },
      selectAll() {
        const status = !this.selectedAll

        this.list.forEach(i => {
          this.$set(i, 'selected', status)
        })

        this.selectedAll = status
      },

      change (b){
          this.changemedia = b;
      },
      selectChecker(i) {
          this.$set(i, 'checked', !i.checked)
      },
      init () {
        const page = this.$route.path
        let type = ''
        let title = ''

        if (page === '/audiotoword') {
          type = 'audio'
          title = '音频语音转文字'
        } else {
          type = 'video'
          title = '视频语音转文字'
        }

        this.pageType = type
        this.headLines.title = title
      },
      getData() {
        const id = this.$route.query.d
        const info = {
          idstring: id
        }

        common.myFetch(apis.File_getWord, info)
        .then(r => {
          if (r) {
            // 获取接口
            this.content = r.content
            this.list = r.res
            this.list.forEach((i, d) => {
              i.o = d
            })

            const file = r. file
            this.info = {
              format: file.format,
              duration: file.duration,
              track: file.vocaltract || file.track,
              rate: file.rate,
              size: file.file_size,
              width: file.resolution,
              user: file.username,
              time: file.raw_add_time,
              url: file.url,
              title: file.title
            }
          }
        })
      },
      exportText(type) {
        const id = this.$route.query.d
        const info = {
          idstring: id,
          type: type
        }
        if (type == 2) {
          info.paragraphs = this.list.filter(i => i.selected).map(j => j.o).join(',')
        }

        const userKeys = common.userKeys()
        const params = Object.assign({}, info, userKeys)

        common.exportRes(apis.File_expTxt, params)
      }
    },
    mounted() {
      this.init()
      this.getData()
    },
    created() {
      let domin = window.document.domain;
      let isXnew = true;
      if(domin.indexOf('xnews')!=-1){
        isXnew = true
      }else if(domin.indexOf('localhost')!=-1){
        isXnew = true
      }else{
        isXnew = false
      }
      this.isXnew = isXnew;
    }
}
</script>

<style src="@assets/css/mediaDetails/mediaChange.less" lang="less" scoped></style>
